/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/extensions
import yaml from 'js-yaml';
import { displayAssociations } from '../Billsby/plans';

/**
 * Filter any given column by checking for case-insensitive text
 * Within the column.  If the filter.id indicates a column whose
 * accessor obtains an array, generate the comparison value by
 * joining the array elements with ' | '.  If the filter.id
 * indicates associationValidations, convert the text appropriately
 * for the comparison.
*/
export const filterMethod = (filter, row) => {
  let value = row[filter.id];
  if (value) {
    if (filter.id === 'associationValidations') {
      value = value ? displayAssociations(value, ' | ') : '';
    } else if (Array.isArray(value)) {
      value = value.join(' | ');
    }
    return value.toLowerCase().includes(filter.value.toLowerCase());
  }
  return false;
}

/**
 * In this case, get the original object used to obtain values for
 * the row and convert it to YAML text.  This allows the search
 * value to find anywhere within the text of the object.
 */
export const otherFilter = (filter, row) => {
  const value = yaml.dump(row._original);
  return value.toLowerCase().includes(filter.value.toLowerCase());
}

export const setFilterPlaceholders = () => {
  // Find all filter inputs in the ReactTable and set their placeholder
  const filterInputs = document.querySelectorAll('.ReactTable .rt-thead.-filters input');
  filterInputs.forEach(input => {
    if (input.placeholder !== 'search') {
      input.placeholder = 'search';
    }
  });
}

export const tooltipColumn = "Search for case-insensitive text within this field";

export const tooltipRow = "Search for case-insensitive text within an entire row including fields not being displayed";



// WEBPACK FOOTER //
// ./src/components/grids/filterFunctions.jsx